// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#fee-vesting-disclaimer-card[data-v-a776c428]{border-radius:16px}#fee-vesting-disclaimer-card i[data-v-a776c428],#fee-vesting-disclaimer-card p[data-v-a776c428]{margin-bottom:10px}#fee-vesting-disclaimer-card p[data-v-a776c428]{font-size:12px!important;letter-spacing:.1px}", ""]);
// Exports
module.exports = exports;
